"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAuditEvent = exports.deserializeAuditEvent = void 0;
const core_1 = require("@js-joda/core");
const deserializeAuditEvent = (messageBody) => {
    const bodyObj = JSON.parse(messageBody);
    if (!bodyObj.timestamp || !bodyObj.timestamptz) {
        throw new Error('Missing timestamps in Audit Event');
    }
    return Object.assign(Object.assign({}, bodyObj), { timestamptz: core_1.ZonedDateTime.parse(bodyObj.timestamptz) });
};
exports.deserializeAuditEvent = deserializeAuditEvent;
const serializeAuditEvent = (event) => {
    return JSON.stringify(Object.assign(Object.assign({}, event), { timestamptz: event.timestamptz.toString() }));
};
exports.serializeAuditEvent = serializeAuditEvent;
